module.exports = __webpack_public_path__ + "img/173-bin.ff29389d.svg";